import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <SEO
        title="Syarat & Ketentuan"
        description="Syarat dan ketentuan penggunaan layanan KasirWA untuk bisnis jasa Indonesia."
        path="/terms"
        noindex={false}
      />
      <header className="bg-white border-b border-slate-100 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#0f6c44] rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-sm">K</span>
            </div>
            <span className="font-bold text-slate-800">KasirWA</span>
          </Link>
          <Link to="/" className="text-sm text-[#0f6c44] hover:underline">Kembali ke Beranda</Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Syarat & Ketentuan</h1>
        <p className="text-slate-500 text-sm mb-8">Terakhir diperbarui: Januari 2026</p>

        <div className="space-y-8 text-slate-700">
          {[
            { title: '1. Penerimaan Syarat', body: 'Dengan mendaftar dan menggunakan KasirWA, Anda menyetujui syarat dan ketentuan ini. Jika Anda tidak setuju, mohon tidak menggunakan layanan kami.' },
            { title: '2. Penggunaan Layanan', body: 'KasirWA disediakan sebagai platform manajemen bisnis jasa. Anda bertanggung jawab untuk memastikan bahwa penggunaan layanan ini sesuai dengan hukum yang berlaku di wilayah Anda.' },
            { title: '3. Akun Pengguna', body: 'Anda bertanggung jawab menjaga kerahasiaan kredensial akun Anda. Segera beritahu kami jika Anda menduga adanya akses tidak sah ke akun Anda.' },
            { title: '4. Data Bisnis', body: 'Data yang Anda masukkan ke KasirWA (pesanan, pelanggan, produk) adalah milik Anda. Anda dapat mengekspor atau menghapus data Anda kapan saja.' },
            { title: '5. Pengiriman WhatsApp', body: 'Fitur notifikasi WhatsApp menggunakan API Fonnte. Anda bertanggung jawab atas konten pesan yang dikirimkan dan harus mematuhi kebijakan penggunaan WhatsApp Business.' },
            { title: '6. Pembatasan Tanggung Jawab', body: 'KasirWA tidak bertanggung jawab atas kerugian bisnis yang timbul dari gangguan layanan, kehilangan data akibat force majeure, atau kesalahan pengguna dalam penggunaan sistem.' },
            { title: '7. Perubahan Layanan', body: 'Kami berhak mengubah, menangguhkan, atau menghentikan layanan (atau bagian darinya) dengan pemberitahuan sebelumnya melalui email atau notifikasi dalam aplikasi.' },
            { title: '8. Hukum yang Berlaku', body: 'Syarat dan ketentuan ini diatur oleh hukum Republik Indonesia. Sengketa yang timbul akan diselesaikan melalui mediasi atau pengadilan yang berwenang di Indonesia.' },
          ].map(s => (
            <section key={s.title}>
              <h2 className="text-xl font-semibold text-slate-800 mb-2">{s.title}</h2>
              <p className="text-sm">{s.body}</p>
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t border-slate-200 mt-16 py-8 text-center text-sm text-slate-400">
        <p>&copy; {new Date().getFullYear()} KasirWA. Semua hak dilindungi.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/privacy" className="hover:text-[#0f6c44]">Privasi</Link>
          <Link to="/terms" className="hover:text-[#0f6c44]">Syarat</Link>
          <Link to="/about" className="hover:text-[#0f6c44]">Tentang</Link>
        </div>
      </footer>
    </div>
  );
}
